import { render, staticRenderFns } from "./TableAfpItems.vue?vue&type=template&id=0105ca9a"
import script from "./TableAfpItems.vue?vue&type=script&lang=ts"
export * from "./TableAfpItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports